import { convertColorToRGBA } from '@/utils/utils';
import { ChatButtonContainer } from './styled';

const ChatButton = (props) => {
  // 按钮图标、按钮状态、设置按钮函数、消息数量
  const { chatIconClose, chatIconOpen, toggleIcon, setToggleIcon, chatConfig, count } = props;

  /**
   * 聊天组件图标地址
   * @returns {string|*}
   */
  const chatIconPath = () => {
    if (chatConfig.chatWindowTriggerIcon) {
      return chatConfig.chatWindowTriggerIcon;
    }
    return toggleIcon ? chatIconClose : chatIconOpen;
  };

  /**
   * 处理点击Chat图标
   */
  const handleClickChatIcon = () => {
    // 切换聊天图标
    setToggleIcon(!toggleIcon);
  };

  return toggleIcon ? (
    <ChatButtonContainer
      style={{
        bottom: chatConfig.mobileIconPosition?.bottom || 'auto',
        right: chatConfig.mobileIconPosition?.right || 'auto',
        top: chatConfig.mobileIconPosition?.top || 'auto',
        left: chatConfig.mobileIconPosition?.left || 'auto',
        background: chatConfig.chatWindowTriggerIcon
          ? 'transparent'
          : `linear-gradient(to bottom, ${convertColorToRGBA(chatConfig.chatThemeColor, '0.5')}, ${
              chatConfig.chatThemeColor
            })`,
      }}
      $chatThemeColorIn={convertColorToRGBA(chatConfig.chatThemeColor, 0.5)}
      $chatThemeColor={chatConfig.chatThemeColor}
      onClick={handleClickChatIcon}
      key={1}
    >
      {count > 0 && (
        <span
          style={{
            position: 'absolute',
            top: -10,
            right: -10,
            background: '#ff4d4f',
            color: 'white',
            borderRadius: '50%',
            minWidth: '18px',
            height: '18px',
            padding: '2px 2px',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {count}
        </span>
      )}
      {chatConfig.chatWindowTriggerIcon ? (
        <img src={chatConfig.chatWindowTriggerIcon} style={{ width: 54, height: 54 }} />
      ) : (
        <img src={chatIconPath()} style={{ width: 30, height: 30 }} />
      )}
    </ChatButtonContainer>
  ) : (
    <ChatButtonContainer
      style={{
        bottom: chatConfig.mobileIconPosition?.bottom || 'auto',
        right: chatConfig.mobileIconPosition?.right || 'auto',
        top: chatConfig.mobileIconPosition?.top || 'auto',
        left: chatConfig.mobileIconPosition?.left || 'auto',
        background: chatConfig.chatWindowTriggerIcon
          ? 'transparent'
          : `linear-gradient(to bottom, ${convertColorToRGBA(chatConfig.chatThemeColor, '0.5')}, ${
              chatConfig.chatThemeColor
            })`,
      }}
      $chatThemeColorIn={convertColorToRGBA(chatConfig.chatThemeColor, '0.5')}
      $chatThemeColor={chatConfig.chatThemeColor}
      onClick={handleClickChatIcon}
      key={2}
    >
      <img
        src={chatIconPath()}
        style={{
          width: chatConfig.chatWindowTriggerIcon ? 54 : 48,
          height: chatConfig.chatWindowTriggerIcon ? 54 : 48,
        }}
      />
      {count > 0 && (
        <span
          style={{
            position: 'absolute',
            top: -10,
            right: -10,
            background: '#ff4d4f',
            color: 'white',
            borderRadius: '50%',
            minWidth: '18px',
            height: '18px',
            padding: '2px 2px',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {count}
        </span>
      )}
    </ChatButtonContainer>
  );
};

export default ChatButton;
